import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PurchaseOrder } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0570. 発注案件詳細
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
  enabled?: boolean;
};
const purchaseOrder = (props: Props): Promise<PurchaseOrder> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.id}`);
};

export const usePurchaseOrder = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => purchaseOrder(props),
    enabled: props.enabled,
  });
};

export const usePurchaseOrderInvalidate = (props: Props) => {
  const invalidate = () => purchaseOrderInvalidate(props);
  return { invalidate };
};

export const purchaseOrderInvalidate = (props: Props) => {
  queryClient.invalidateQueries({ queryKey: queryKey(props) });
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'purchase_orders', props.id];
};
